import React, { useState, useEffect } from 'react';

import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar, ResponsiveContainer,
} from 'recharts';

const mockLossData = [
  { epoch: 1, loss: 0.9 },
  { epoch: 2, loss: 0.6 },
  { epoch: 3, loss: 0.45 },
  { epoch: 4, loss: 0.32 },
  { epoch: 5, loss: 0.21 },
];

const mockFpsData = [
  { algorithm: 'SPTNet', fps: 22 },
  { algorithm: 'uTrack', fps: 15 },
  { algorithm: 'TrackMate', fps: 12 },
  { algorithm: 'DeepTrack', fps: 18 },
];

const TrainingChart = () => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-md border space-y-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">📈 Training Loss Over Epochs</h2>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={mockLossData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="epoch" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="loss" stroke="#8884d8" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>

      <h2 className="text-xl font-bold text-gray-800 mt-6 mb-4">⚡ FPS Comparison by Algorithm</h2>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={mockFpsData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="algorithm" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="fps" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrainingChart;
